import { useRouter } from 'preact-router';

import Header from '@/components/Header';
import { LayoutDetector, MOBILE_LAYOUT_BREAKPOINT } from '@/components/LayoutDetector';
import PageWrapper from '@/components/Main/PageWrapper';
import ShareModal from '@/components/ShareModal/Modal';
import useVerifyEmailGate from '@/components/SpeedyFlow/hooks/useVerifyEmailGate';
import useHabitatTour from '@/components/TourOnboarding/useHabitatTour';
import { setQueryParams } from '@/hooks/route';
import HomeLayout from '@/layouts/Home';
import { useSelector } from '@/redux/helper';
import { selectIsGuestSessionLocked } from '@/redux/slices/deviceSettings/selectors';

import Habitats from '../habitats/Habitats';
import HomeContent from './HomeContent';

const HomeDesktop = () => {
  // initialize habitat tour logic (desktop, ATM only for educators)
  useHabitatTour();
  return (
    <>
      <Header />
      <PageWrapper>
        <HomeLayout>
          <HomeContent />
        </HomeLayout>
      </PageWrapper>
    </>
  );
};

const HomeMobile = () => {
  const [{ matches }] = useRouter();
  const { mediaId } = matches ?? {};
  const isGuestSessionLocked = useSelector((state) => selectIsGuestSessionLocked(state, null));
  return (
    <>
      <Habitats />
      {isGuestSessionLocked ? null : mediaId ? (
        <ShareModal
          open
          shouldLoadPubnub
          mediaId={mediaId}
          isDrawer
          onClose={() => {
            setQueryParams({ mediaId: undefined, playlistId: undefined, type: undefined }, true);
          }}
        />
      ) : null}
    </>
  );
};

const HomeWithLayout = () => {
  useVerifyEmailGate();

  return (
    <LayoutDetector
      title="Habitats"
      breakPoint={MOBILE_LAYOUT_BREAKPOINT}
      desktop={<HomeDesktop />}
      mobile={<HomeMobile />}
    />
  );
};

export default HomeWithLayout;
